export default {"src":"/_next/static/media/SO.948259db.svg","height":18,"width":18};